import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=61a0b2b0&scoped=true&"
import script from "./Finished.vue?vue&type=script&lang=js&"
export * from "./Finished.vue?vue&type=script&lang=js&"
import style0 from "./Finished.vue?vue&type=style&index=0&id=61a0b2b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0b2b0",
  null
  
)

export default component.exports